import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IFavorites } from '@interfaces/favorite';

export interface IFavoritesState extends IFavorites {}

export const INITIAL_STATE: IFavoritesState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
		totalItems: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class FavoritesStore {
	private readonly _favoritesState = new BehaviorSubject<IFavoritesState>(
		INITIAL_STATE
	);
	readonly favoritesState$ = this._favoritesState.asObservable();

	updateProducts(favorites: IFavoritesState) {
		const state = this._favoritesState.value;

		const data = { ...state, ...favorites };

		this._favoritesState.next(data);

		return this.favoritesState$;
	}
}
